import { CurrencyProps, EndpointReponseProps } from "../types";
// const baseURL = "http://localhost:8080/api";
const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
// const baseURL = `${process.env.REACT_APP_BASE_URL_DEV}/api`;
const overseerBaseURL = `${process.env.REACT_APP_OVERSEER_BASE_URL}/api`;
export const Endpoints = {
  GetStudentLocation: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/location`,
      method: "POST",
    };
  },
  GetStudentLoginWithEmailAndPassword: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/login`,
      method: "POST",
    };
  },
  GetStudentLoginWithOtpSend: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/login/otp/send`,
      method: "POST",
    };
  },
  GetStudentLoginWithOtpValidate: (tokenID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/login/otp/validate/${tokenID}`,
      method: "POST",
    };
  },
  GetStudentCertificate: (
    certificateID: any,
    courseID: any
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/certificate/${certificateID}/${courseID}`,
      method: "GET",
    };
  },
  GetStudentSignup: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/signup`,
      method: "POST",
    };
  },
  GetStudentProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/profile`,
      method: "GET",
    };
  },
  GetResendVerificationEmail: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/resend-verification-email`,
      method: "POST",
    };
  },
  GetStudentEarlyBirdDiscount: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/p/discount-status`,
      method: "GET",
    };
  },
  GetStudentStripeCustomer: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/stripe-profile`,
      method: "GET",
    };
  },

  GetStudentUpdateAddress: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/address`,
      method: "PUT",
    };
  },
  GetRequestResetPassword: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/request-reset`,
      method: "POST",
    };
  },
  GetVerifyEmail: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/verify-email?token=${token}`,
      method: "GET",
    };
  },
  GetPlans: (currency?: CurrencyProps): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/plans/get?currency=${currency ?? "USD"}`,
      method: "GET",
    };
  },

  GetSinglePlanDetails: (
    planID: string,
    currency?: CurrencyProps
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/plan/${planID}/${currency ?? "USD"}`,
      method: "GET",
    };
  },

  GetCourses: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/courses/get?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },
  GetPurchasedCourses: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/courses/purchased`,
      method: "GET",
    };
  },

  GetSingleCourseDetails: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/course/${courseID}`,
      method: "GET",
    };
  },
  GetSingleCourseDetailsAuth: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/course/${courseID}`,
      method: "GET",
    };
  },

  // BEGIN FLUTTERWAVE VERSION 3 ENDPOINTS
  GetSubscribeWithFlutterwaveV3: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/flutterwave/v3/subscribe`,
      method: "POST",
    };
  },
  GetValidateCodeWithFlutterwaveV3: (
    transactionID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/flutterwave/v3/validate-card-charge-code/${transactionID}`,
      method: "POST",
    };
  },
  // END FLUTTERWAVE VERSION 3 ENDPOINTS
  // - - - - - - - - - - -
  // START FLUTTERWAVE VERSION 4 ENDPOINTS
  GetSubscribeWithFlutterwaveV4: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/flutterwave/v4/subscribe`,
      method: "POST",
    };
  },
  // END FLUTTERWAVE VERSION 4 ENDPOINTS
  // - - - - - - - - - - - - -

  GetCreateStripeSubscription: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/stripe/subscribe`,
      method: "POST",
    };
  },
  GetSubscriptions: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/p/subscriptions`,
      method: "GET",
    };
  },
  GetCancelStripeSubscription: (planID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/stripe/${planID}`,
      method: "DELETE",
    };
  },

  GetInitializePaystackPayment: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/paystack/subscription/initialize`,
      method: "POST",
    };
  },
  GetValidatePaystackPayment: (reference: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/paystack/subscription/validate/${reference}`,
      method: "GET",
    };
  },

  GetCancelSubscription: (subscriptionID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/p/subscription/${subscriptionID}`,
      method: "DELETE",
    };
  },
  GetTransactions: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/p/transactions?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleTeacherProfile: (teacherID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/teacher/${teacherID}`,
      method: "GET",
    };
  },
  GetLessonsForCalendar: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/calendar`,
      method: "GET",
    };
  },
  GetLessonsUnderCourse: (
    courseID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/lessons/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleLessonDetails: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/lesson/${lessonID}`,
      method: "GET",
    };
  },
  GetLessonRoomDetails: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/room/${lessonID}`,
      method: "GET",
    };
  },
  GetAssessmentsUnderLesson: (
    lessonID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/assessments/${lessonID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleAssessmentDetails: (assessmentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/assessment/${assessmentID}`,
      method: "GET",
    };
  },
  GetSubmitAssessment: (assessmentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/assessment/submit/${assessmentID}`,
      method: "POST",
    };
  },

  GetStudentPerformanceInSingleCourse: (
    courseID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/performance/${courseID}`,
      method: "GET",
    };
  },
  GetStudentPerformanceInAllCourses: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/performance`,
      method: "GET",
    };
  },

  GetLessonMaterials: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/materials/${lessonID}`,
      method: "GET",
    };
  },
  GetConversations: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/conversations`,
      method: "GET",
    };
  },
  GetConversationWithParticipant: (
    participantConversationID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/conversation/${participantConversationID}`,
      method: "GET",
    };
  },

  GetEntityProfile: (entityID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/c/entity/${entityID}`,
      method: "POST",
    };
  },

  GetSendMessage: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/c/send`,
      method: "POST",
    };
  },

  GetSearchCourses: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/search/courses`,
      method: "POST",
    };
  },
  GetBlogs: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/blog/all/fr?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleBlog: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/blog/${blogID}`,
      method: "GET",
    };
  },
  GetToggleLikeBlog: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/blog/${blogID}`,
      method: "PATCH",
    };
  },
  GetAddCommentToBlog: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/blog/${blogID}`,
      method: "PUT",
    };
  },
  GetDeleteCommentFromBlog: (
    blogID: string,
    commentID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/blog/${blogID}/${commentID}`,
      method: "DELETE",
    };
  },

  GetDeleteStudentAccount: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/auth/delete`,
      method: "DELETE",
    };
  },
  GetAllRecordingsEver: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/recordings?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetAllRecordingsUnderCourse: (
    courseID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/recordings/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleRecording: (recordingID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/student/recording/${recordingID}`,
      method: "GET",
    };
  },

  GetAssets: (): EndpointReponseProps => {
    return {
      route: `${overseerBaseURL}/assets`,
      method: "GET",
    };
  },

  GetUploadFile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/file/upload`,
      method: "POST",
    };
  },
};
